import { createListCollection } from '@chakra-ui/react';
import { getDefaultOptionSelection, getOrderedListingImageUuids, isVariationOptionDisabled, sortByOrder, } from '@heirloom/common/domain/listing';
import { useMemo, useState } from 'react';
export const useVariationSelection = (listingData) => {
    const [userSelection, setUserSelection] = useState(null);
    const defaultOptions = useMemo(() => listingData
        ? getDefaultOptionSelection(listingData)
        : null, [listingData]);
    const selectedVariationOptions = userSelection &&
        userSelection.listingShortId === listingData?.shortId
        ? userSelection.options
        : (defaultOptions?.selection ?? {});
    const selectOption = (variationId, optionId) => {
        if (!listingData)
            return;
        setUserSelection({
            listingShortId: listingData.shortId,
            options: {
                ...selectedVariationOptions,
                [variationId]: optionId,
            },
        });
    };
    const orderedImageUuids = listingData
        ? getOrderedListingImageUuids(listingData, selectedVariationOptions)
        : [];
    const variationCollections = listingData
        ? sortByOrder(listingData.variations).map(([varId, variation]) => ({
            id: varId,
            name: variation.name,
            collection: createListCollection({
                items: sortByOrder(variation.options).map(([optId, option]) => ({
                    value: optId,
                    label: option.name,
                    disabled: isVariationOptionDisabled(varId, optId, selectedVariationOptions, listingData),
                })),
            }),
        }))
        : [];
    const allVariationsSelected = listingData
        ? Object.keys(listingData.variations).every((id) => selectedVariationOptions[id] != null)
        : false;
    return {
        selectedVariationOptions,
        selectOption,
        hasAvailableOption: defaultOptions?.isAvailable ?? true,
        orderedImageUuids,
        variationCollections,
        allVariationsSelected,
    };
};
